import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import MessageUI from '../../widgets/output/MessageUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import FBLoginSF from '../../components/login/FBLoginSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import GoogleLoginSF from '../../components/login/GoogleLoginSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import SignUpOnInviteAcceptSF from '../../components/public/SignUpOnInviteAcceptSF'

const InviteAcceptPageUI = ({context, messageList, newUser,
    userId, accountId, email, firstName, lastName, accountName,
    socialLoginUrl, errorList, showFBLogin}) =>
  <PublicPageSF context={context} className='pg_inv_acc' centered={!messageList || (errorList && errorList.length > 0)}
    messageList={messageList} headerMessageKey={newUser ? 'c_sign_up' : 'c_invitation_accepted'}>
    {
      !messageList &&
      <SpinnerComponentUI />
    }
    {
      messageList && (errorList && errorList.length > 0) &&
      <div className='g_text_center'>
        {errorList[0].message}
        <div className='g_m_top_100'>
          <ButtonLinkUI to='/' messageList={messageList} labelKey='c_continue' transparent={true} />
        </div>
      </div>
    }
    {
      messageList && !(errorList && errorList.length > 0) &&
      <React.Fragment>
        <PageTitleUI context={context}
          messageList={messageList} titleMessageKey={newUser ? 'c_sign_up' : 'c_invitation_accepted'}
        />
        {
          !newUser &&
          <React.Fragment>
            <CardUI>
              <MessageUI messageList={messageList} messageKey={context.session.userId ? 'c_acct_inv_acpt_goacc' : 'c_acct_inv_acpt_signin'}
                args={[accountName, email]} />
              <div className='g_text_right g_m_top_100'>
                <ButtonLinkUI messageList={messageList} labelKey='c_continue' to='/' />
              </div>
            </CardUI>
          </React.Fragment>
        }
        {
          newUser &&
          <React.Fragment>
            <SignUpOnInviteAcceptSF
              context={context}
              userId={userId}
              accountId={accountId}
              email={email}
              firstName={firstName}
              lastName={lastName}
              accountName={accountName}
            />
            <div className='social'>
              <div className='g_text_center g_m_top_100'>
                <MessageUI messageList={messageList} messageKey='c_or' />
              </div>

              <div className='google'>
                <GoogleLoginSF context={context} messageList={messageList} socialLoginUrl={socialLoginUrl} />
              </div>

              {
                showFBLogin &&
                <div className='facebook'>
                  <FBLoginSF context={context} messageList={messageList} socialLoginUrl={socialLoginUrl} />
                </div>
              }
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    }
  </PublicPageSF>

export default InviteAcceptPageUI
